<template>
  <div class="p-box">
    <div class="p-box__body">
      <div class="p-table">
        <div class="p-table__content">
          <table>
            <thead>
              <tr>
                <th><span>{{ $t('pages.CompaniesExportResults.item.type') }}</span></th>
                <th><span>{{ $t('pages.CompaniesExportResults.item.start_at') }}</span></th>
                <th><span>{{ $t('pages.CompaniesExportResults.item.status') }}</span></th>
                <th v-if="!loading && companiesExportResults.length && companiesExportResults.find(v => v.attributes.csv_download_url)" />
              </tr>
              <tr class="p-table__content__space">
                <td colspan="4" />
              </tr>
            </thead>
            <tbody v-if="!loading && companiesExportResults">
              <tr v-for="( item, i ) in companiesExportResults" :key="i">
                <td class="p-table__content__index">{{ $t(`pages.CompaniesExportResults.type.${ camelCase(item.attributes.csv_type) }`) }}</td>
                <td class="p-table__content__index">{{ item.attributes.start_at }}</td>
                <td class="p-table__content__index">{{ $t(`pages.CompaniesExportResults.status.${ item.attributes.status }`) }}</td>
                <td v-if="companiesExportResults.find(v => v.attributes.csv_download_url)" class="p-table__content__index">
                  <button
                    v-show="item.attributes.csv_download_url"
                    type="button"
                    class="p-controller__navi__next"
                  >
                    <a :href="item.attributes.csv_download_url">{{ $t('pages.CompaniesExportResults.download') }}</a>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <Loading v-show="loading" />
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import Loading from '../components/Loading'
import { camelCase } from '../modules/string_converter'

export default {
  name: 'CompaniesExportResults',
  components: {
    Loading,
  },
  computed: {
    ...mapState({
      companiesExportResults: state => state.companiesExportResults.data,
      loading: state => state.companiesExportResults.loading,
    })
  },
  created() {
    const payload = {
      company_uuid: this.$route.params.company_uuid,
    }
    this.readCompaniesExportResults(payload)
  },
  methods: {
    ...mapActions({
      readCompaniesExportResults: 'companiesExportResults/readCompaniesExportResults',
    }),
    camelCase(str){
      return camelCase(str)
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
